import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductViewSpecificationComponent } from '../../catalog/product/view-specification/product-view-specification.component';
@Component({
    selector: 'basket-item-product-specification',
    templateUrl: 'basket-item-product-specification.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class BasketItemProductSpecificationComponent extends ProductViewSpecificationComponent {
}
